import { EntitySwitch, isKind } from '@backstage/plugin-catalog';
import { componentEntity } from './entities/Component';
import { ApiEntity } from './entities/Api';
import { groupEntity } from './entities/Group';
import { UserEntity } from './entities/User';
import { domainEntity } from './entities/Domain';
import { defaultEntity } from './entities/Default';
import { systemEntity } from './entities/System';

export const entityPageContent = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('component')}>
      {componentEntity}
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('api')}>
      <ApiEntity />
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('group')}>{groupEntity}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('user')}>
      <UserEntity />
    </EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('domain')}>{domainEntity}</EntitySwitch.Case>
    <EntitySwitch.Case if={isKind('system')}>{systemEntity}</EntitySwitch.Case>
    <EntitySwitch.Case>{defaultEntity}</EntitySwitch.Case>
  </EntitySwitch>
);
